import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import * as ROUTES from '../constants/routes';
import Icon from './Icon';

const pageLinks = [
  {
    route: ROUTES.ABOUT,
    labelKey: 'footer.about',
  },
  {
    route: ROUTES.CONTACT,
    labelKey: 'footer.contact',
  },
  {
    route: ROUTES.TOS,
    labelKey: 'footer.tos',
  },
  {
    route: ROUTES.PP,
    labelKey: 'footer.privacy',
  },
  {
    route: ROUTES.CU,
    labelKey: 'footer.cookies',
  },
];

const socialPages = [
  {
    url: 'https://www.facebook.com/reputelo',
    icon: 'facebook',
  },
  {
    url: 'https://www.instagram.com/reputelo_ig/',
    icon: 'instagram',
  },
  {
    url: 'https://x.com/reputelo',
    icon: 'x-twitter',
  },
  {
    url: 'https://www.youtube.com/@reputelo',
    icon: 'youtube',
  },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="container mt-3">
        <div className="row">
          <div className="col d-flex justify-content-start">
            <span className="float-left mr-2">{t('footer.copyright')}</span>
            <ul className="list-inline">
              {pageLinks.map(page => (
                <li key={page.route} className="list-inline-item">
                  <Link to={page.route}>{t(page.labelKey)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-auto d-flex justify-content-end">
            <ul className="list-inline">
              {socialPages.map(page => (
                <li key={page.url} className="list-inline-item">
                  <a href={page.url} target="_blank" rel="noopener noreferrer">
                    <Icon icon={['fab', page.icon]} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
